import { type ChatActionHandler } from './types';
import { CreateTicketAction } from './create-ticket.action';
import { CallCustomerAction } from './call-customer.action';
import { ViewUrlAction } from './view-url.action';
import { MsgTlAction } from './msg-tl.action';

export * from './types';

export const chatActionRegistry: Record<string, ChatActionHandler> = {
  CREATE_TICKET: CreateTicketAction,
  CALL_CUSTOMER: CallCustomerAction,
  VIEW_URL: ViewUrlAction,
  MSG_TL: MsgTlAction,
};
